import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Table,
  message,
} from "antd";
import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { auth, db } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import {
  collection,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";

const AdditionalFees = ({ data, dataId }) => {
  const [user, loading] = useAuthState(auth);
  const [companyName, setCompanyName] = useState("");
  const [isEditActive, setIsEditActive] = useState(false);
  const [isWaiting, setIsWaiting] = useState(false);
  const [leaseFeeType, setleaseFeeType] = useState(
    data?.leaseFee?.leaseFeeType
  );
  const [renewalType, setRenewalType] = useState(
    data?.renewalFee?.renewalFeeType
  );

  const handleLeaseFeeType = (e) => {
    setleaseFeeType(e.target.value);
  };

  const handleRenewalType = (e) => {
    setRenewalType(e.target.value);
  };

  console.log("AdditionalFees:", data);

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const tableHeader = [
    {
      title: "GL Account",
      dataIndex: "GLAccount",
      key: "GLAccount",
      render: (_, record) => <p>{record.glAccount}</p>,
    },
    {
      title: "Percentage",
      dataIndex: "Percentage",
      key: "Percentage",
      render: (_, record) => <p>{record.percentage}</p>,
    },
    {
      title: "suppress",
      dataIndex: "suppress",
      key: "suppress",
      render: (_, record) => <p>{record.suppress ? "Yes" : "No"}</p>,
    },
  ];

  const [renwalFees, setRenewalFees] = useState([
    { id: uuidv4(), glAccount: "", percentage: "", suppress: false },
  ]);

  const onFinish = async (values) => {
    setIsWaiting(true);

    const renewals = renwalFees.filter((item) => {
      return Object.keys(item).some(
        (key) => key !== "id" && key !== "suppress" && item[key] !== ""
      );
    });

    try {
      const propertyRef = doc(
        db,
        "companies",
        companyName,
        "properties",
        dataId
      );
      const renewalFees = {
        additionalFees: {
          additionalFeeDetails: renewals,
          leaseFee: {
            leaseFee: values.leaseFee,
            leaseFeeType: leaseFeeType,
          },
          renewalFee: {
            renewalFee: values.renewalFee,
            renewalFeeType: renewalType,
          },
        },
      };
      await updateDoc(propertyRef, renewalFees);
      setTimeout(() => {
        setIsEditActive(false);
        setIsWaiting(false);
      }, 3000);
      message.success("additional fee updated successfully..", 3);
    } catch (error) {
      console.error("not updated:", error);
      setIsWaiting(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const defaultValues = {
    leaseFeeType: data?.leaseFee?.leaseFeeType,
    leaseFee: data?.leaseFee?.leaseFee,
    renewalFeeType: data?.renewalFee?.renewalFeeType,
    renewalFee: data?.renewalFee?.renewalFee,
  };

  useEffect(() => {
    if (companyName) {
      const fetchTenants = async () => {
        try {
          const tenantRef = collection(
            db,
            "companies",
            companyName,
            "properties"
          );
          const snapshot = await getDocs(tenantRef);
          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          const filteredTenant = fetchedData.find((item) => item.id === dataId);
          setRenewalFees(
            filteredTenant?.additionalFees?.additionalFeeDetails?.length >= 1
              ? filteredTenant?.additionalFees?.additionalFeeDetails
              : [
                  {
                    id: uuidv4(),
                    glAccount: "",
                    percentage: "",
                    suppress: false,
                  },
                ]
          );
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchTenants();
    }
  }, [companyName, isEditActive]);

  const addRenewal = () => {
    const newRenewalFees = {
      id: uuidv4(),
      glAccount: "",
      percentage: "",
      suppress: false,
    };
    setRenewalFees([...renwalFees, newRenewalFees]);
  };

  const removeRenewal = (id) => {
    const updatedRenwalFees = renwalFees.filter((term) => term.id !== id);
    setRenewalFees(updatedRenwalFees);
  };

  const handleChange = (value, name, id) => {
    const newRenewalFees = renwalFees.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setRenewalFees(newRenewalFees);
  };

  return (
    <div>
      <Card
        title="Additional Fees"
        extra={
          !isEditActive ? (
            <Button
              type="link"
              onClick={() => {
                setIsEditActive(true);
              }}
            >
              Edit
            </Button>
          ) : (
            ""
          )
        }
      >
        <Form
          name="basic"
          labelCol={{
            span: 10,
            offset: 0,
          }}
          wrapperCol={{
            span: 16,
          }}
          initialValues={defaultValues}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          colon={false}
        >
          {/* <h4>Lease Fee</h4> */}

          <Form.Item label="Lease Fee Type" name="leaseFeeType">
            {isEditActive ? (
              <Radio.Group onChange={handleLeaseFeeType}>
                <Space direction="horizontal">
                  <Radio value="Flat">Flat</Radio>
                  <Radio value="Percent">Percent</Radio>
                </Space>
              </Radio.Group>
            ) : (
              <p>
                {data?.leaseFee?.leaseFeeType
                  ? data?.leaseFee?.leaseFeeType
                  : "--"}
              </p>
            )}
          </Form.Item>
          <Form.Item label="Lease Flat Fee" name="leaseFee">
            {isEditActive ? (
              <Input
                type="Number"
                prefix={leaseFeeType === "Flat" ? "$" : "%"}
              />
            ) : (
              <p>
                {data?.leaseFee?.leaseFee ? data?.leaseFee?.leaseFee : "--"}
              </p>
            )}
          </Form.Item>

          <h4>Renewal Fee </h4>

          <Form.Item label="Renewal Fee Type" name="renewalFeeType">
            {isEditActive ? (
              <Radio.Group onChange={handleRenewalType}>
                <Space direction="horizontal">
                  <Radio value="Flat">Flat</Radio>
                  <Radio value="Percent">Percent</Radio>
                </Space>
              </Radio.Group>
            ) : (
              <p>
                {data?.renewalFee?.renewalFeeType
                  ? data?.renewalFee?.renewalFeeType
                  : "--"}
              </p>
            )}
          </Form.Item>
          <Form.Item label="Renewal Flat Fee" name="renewalFee">
            {isEditActive ? (
              <Input
                type="Number"
                prefix={renewalType === "Flat" ? "$" : "%"}
              />
            ) : (
              <p>
                {data?.renewalFee?.renewalFee
                  ? data?.renewalFee?.renewalFee
                  : "--"}
              </p>
            )}
          </Form.Item>

          <h4>Additional Fees</h4>

          {isEditActive ? (
            <ul>
              <Row gutter={16} style={{ marginBottom: 12 }}>
                <Col className="tableHead" span={11}>
                  <p>GL Account</p>
                </Col>
                <Col className="tableHead" span={10}>
                  <p>Percentage</p>
                </Col>
                <Col className="tableHead" span={2}>
                  <p>Suppress</p>
                </Col>
                <Col span={1}></Col>
              </Row>
              {renwalFees?.map((item) => (
                <li key={item.id}>
                  <Row gutter={16} style={{ marginBottom: "10px" }}>
                    <Col span={11}>
                      <Select
                        showSearch
                        options={[
                          { value: "Every charge" },
                          { value: "All recurring charge" },
                          { value: "Only recurring rent" },
                        ]}
                        value={item.glAccount}
                        onChange={(value) =>
                          handleChange(value, "glAccount", item.id)
                        }
                        style={{ width: "100%" }}
                      />
                    </Col>
                    <Col span={10}>
                      <Input
                        type="Number"
                        suffix={<i className="fa-solid fa-percent"></i>}
                        value={item.percentage}
                        onChange={(e) =>
                          handleChange(e.target.value, "percentage", item.id)
                        }
                      />
                    </Col>
                    <Col span={2}>
                      <Checkbox
                        checked={item.suppress}
                        onChange={(e) =>
                          handleChange(e.target.checked, "suppress", item.id)
                        }
                      />
                    </Col>
                    <Col span={1}>
                      {renwalFees.length > 1 ? (
                        <Button
                          className="roundSmallButton"
                          onClick={() => {
                            removeRenewal(item.id);
                          }}
                          type="primary"
                          shape="circle"
                          icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                          size={"small"}
                        />
                      ) : (
                        <></>
                      )}
                    </Col>
                  </Row>
                </li>
              ))}
              <Form.Item label="">
                <Button
                  className="addPropertyGroupButton"
                  type="primary"
                  onClick={addRenewal}
                  size={"small"}
                  icon={<i className="fa-solid fa-circle-plus"></i>}
                >
                  Add Another Renewal
                </Button>
              </Form.Item>
            </ul>
          ) : (
            <Table
              columns={tableHeader}
              dataSource={renwalFees}
              size="small"
              pagination={false}
            />
          )}

          {isEditActive && (
            <Row gutter={16}>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isWaiting}>
                  {isWaiting ? "Please wait..." : "Save"}
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    setIsEditActive(false);
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </Card>
    </div>
  );
};

export default AdditionalFees;
